/**
 * Publishes the company's nutrition unit to the tree below it.
 *
 * The flag is the logged-in user's `nutritionPointsEnabled`, resolved server-side from their
 * company — the same switch that turns the trainee app to points. A coach therefore sees a trainee's
 * nutrition in the unit the trainee sees it in.
 *
 * Polarity is `=== true`: before `/user/me` lands, and for a company-less user (a super-admin not
 * impersonating anyone), the answer is calories.
 */

import { useMemo } from "react";
import type { ReactNode } from "react";
import { useAuth } from "./AuthContext";
import { NutritionDisplayContext } from "./NutritionDisplayContext";
import { CALORIES, POINTS } from "../componenets/nutrition/v2/ui/nutritionUnits";

export function NutritionDisplayProvider({ children }: { children: ReactNode }) {
  const { currentUser } = useAuth();
  const enabled = currentUser?.nutritionPointsEnabled === true;
  const mode = useMemo(() => (enabled ? POINTS : CALORIES), [enabled]);

  return <NutritionDisplayContext.Provider value={mode}>{children}</NutritionDisplayContext.Provider>;
}
